import React, { KeyboardEvent, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { InputText } from '~/components/NovosInputs';
import { CustomButtonNovo } from '~/components/Buttons/CustomButtonNovo';
import { BiCheck } from 'react-icons/bi';
import { useModulo } from '../../hooks/useModulo';
import { nanoid } from 'nanoid';
import { insertOrUpdate } from '~/utils/masterDetail';
import { toast } from 'react-toastify';

export const ModalSubModulos: React.FC = () => {
  const {
    formModal,
    openModal,
    handleOpenModal,
    setRows,
    masterDetail,
    setMasterDetail,
    isEditing,
    setIsEditing,
    rows,
  } = useModulo();
  const {
    handleSubmit,
    register,
    reset,
    control,
    formState: { errors },
  } = formModal;

  useEffect(() => {
    if (openModal) {
      const input = document.getElementById('desModulo') as HTMLInputElement;
      if (input) {
        setTimeout(() => {
          input.click();
          input.focus();
        }, 100);
      }
    }
  }, [openModal]);

  const onSave = handleSubmit(async (data) => {
    const isEdit = Boolean(isEditing);

    const newModulo: any = {
      uuid: isEdit ? isEditing?.uuid : nanoid(),
      cod_seq_modulo_secao: isEdit
        ? isEditing?.cod_seq_modulo_secao
        : undefined,
      num_ordem_menu: isEdit ? isEditing?.num_ordem_menu : rows.length + 1,
      des_modulo_secao: data.des_modulo_secao,
      qtd_telas: isEdit ? isEditing?.qtd_telas : 0,
    };

    const existDes = rows.find(
      (modulo) =>
        modulo.des_modulo_secao.toLowerCase() ===
          newModulo.des_modulo_secao.toLowerCase() &&
        modulo.uuid !== newModulo.uuid,
    );
    if (existDes) {
      return toast.warn('Já existe um Submódulo com essa descrição.');
    }

    await insertOrUpdate(
      'subModulos',
      newModulo,
      masterDetail,
      setMasterDetail,
    );

    handleClose();
    reset();
    return setRows([...rows, newModulo]);
  });

  const handleClose = () => {
    handleOpenModal(false);
    setIsEditing(null);
    reset();
  };
  return (
    <>
      <Modal show={openModal} centered onHide={handleClose} size="xl">
        <Modal.Header>
          <Modal.Title>
            {isEditing ? 'Editar Submódulo' : 'Adicionar Submódulo'}
          </Modal.Title>
          <button
            type="button"
            onClick={handleClose}
            disabled={false}
            style={{
              right: '10px',
              top: '10px',
              fontSize: '20px',
              cursor: 'pointer',
              outline: 'none',
              background: 'none',
              border: 'none',
              opacity: 1,
            }}
          >
            x
          </button>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div>
              <InputText
                id="desModulo"
                label="Descrição"
                name="des_modulo_secao"
                placeholder="Informe a Descrição"
                caseInput="upper"
                control={control}
                register={register}
                maxLength={50}
                isError={!!errors.des_modulo_secao}
                onKeyPress={(event: KeyboardEvent<HTMLInputElement>) => {
                  if (event.key === 'Enter') {
                    return onSave();
                  }
                }}
              />
            </div>
            <div className="d-flex justify-content-end align-items-center mt-4">
              <CustomButtonNovo
                onClick={onSave}
                width="200px"
                variant="confirm"
                label="Gravar"
                icon={BiCheck}
                disabled={false}
                showLoading={false}
              />
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};
